import { TableCell } from "@mui/material";
import React from "react";
import {
  getBrokerOrdersTable,
  getStepShekarChanceTable,
  refreshStepOrder,
} from "../../../Requests/stepRequests";
import useRequest from "../../../Hooks/useRequest";
import { toast } from "react-toastify";
import HuntStrategyChancesTable from "../../Order/HuntChances/HuntStrategyChancesTable";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import RefreshIcon from "@mui/icons-material/Refresh";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { OrderStrategy } from "../../../Interfaces/orderInterfaces";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import SubOrdersTable from "../SubOrder/SubOrdersTable";
import {
  IManualActionsTableSearchParam,
  IManualTradeTableReport,
} from "../../../Interfaces/manualInterfaces";
import SahraOrderTable from "../SahraOrder/SahraOrderTable";
import { getManualSahraOrderTable } from "../../../Requests/manualRequests";
import ActionsTable from "../ActionsTable";

const ManualTradeTableAdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const ManualTradeTableAdditionalCol: React.FC<{
  row: IManualTradeTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isChancesOpen, setIsChancesOpen] = React.useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] =
    React.useState(false);
  const [isActionsTableModalOpen, setIsActionsTableModalOpen] =
    React.useState(false);

  const refreshOrderRequest = useRequest(
    () => refreshStepOrder(row.sahraUserId),
    errorHandler
  );

  React.useEffect(() => {
    if (refreshOrderRequest.response)
      toast.success(refreshOrderRequest.response.msg);
  }, [refreshOrderRequest.response]);

  function errorHandler(e: any) {
    let error: any;

    if (!e) error = "خطا در ارتباط با سرور";
    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    toast.error(error);
  }

  const refreshOrderClickHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    refreshOrderRequest.fetchData();
    onAction();
  };

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  return (
    <>
      <TableCell>
        {refreshOrderRequest.loading ? <FullScreenLoading /> : null}
        <RefreshIcon
          fontSize="small"
          onClick={refreshOrderClickHandler}
          className="text-sky-800 cursor-pointer"
        />
      </TableCell>
      <TableCell>
        {isActionsTableModalOpen ? (
          <Modal
            UI={
              <ActionsTable
                searchParams={
                  {
                    manualStepOrderId: row.id,
                    manualOrderId: null,
                  } as IManualActionsTableSearchParam
                }
              />
            }
            onClose={() => setIsActionsTableModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsActionsTableModalOpen(true)}
          text="عملیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>

      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal
            UI={
              <SahraOrderTable
                getData={getManualSahraOrderTable}
                searchParam={{ manualStepOrderId: row.id }}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isOpen ? (
          <Modal
            UI={<SubOrdersTable manualStepOrderId={row.id} />}
            onClose={() => setIsOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsOpen(true)}
          text="جزئیات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      {/* <TableCell>
        {isChancesOpen ? (
          <Modal
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getStepShekarChanceTable(
                    { stepOrderId: row.id },
                    offset,
                    pageSize
                  )
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        {row.orderStrategy === OrderStrategy.Hunt ? (
          <Button
            onClick={btnClickHandler}
            text="شانس ها"
            variant="contained"
            className="table-btn"
          />
        ) : null}
      </TableCell> */}
    </>
  );
};

export const ManualTradeTableAdditional: IAdditional<IManualTradeTableReport> =
  {
    getHeader: ManualTradeTableAdditionalHeader,
    getRow: ManualTradeTableAdditionalCol,
  };
